import { render } from "./ClockScoreNum.vue?vue&type=template&id=6d520b06&scoped=true"
import script from "./ClockScoreNum.vue?vue&type=script&lang=js"
export * from "./ClockScoreNum.vue?vue&type=script&lang=js"

import "./ClockScoreNum.vue?vue&type=style&index=0&id=6d520b06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d520b06"]])

export default __exports__